export default "__VITE_PUBLIC_ASSET__b285815e__"